import { render } from "./ImportPimProducts.vue?vue&type=template&id=3f3c1b1c&scoped=true&ts=true"
import script from "./ImportPimProducts.vue?vue&type=script&lang=ts"
export * from "./ImportPimProducts.vue?vue&type=script&lang=ts"

import "./ImportPimProducts.vue?vue&type=style&index=0&id=3f3c1b1c&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f3c1b1c"]])

export default __exports__